import { create } from 'zustand';
import { getPlanningWeeks } from '../api/generated/planning-weeks/planning-weeks';
import { getCopyWeek } from '../api/generated/copy-week/copy-week';
import type {
  FacilityFlowApiControllersPlanningPlanningWeeksControllerPlanEntryDto,
  FacilityFlowCoreModulesPlanningDtosCopyWeekCopyWeekResultDto,
} from '../api/generated/models';

const api = getPlanningWeeks();
const copyWeekApi = getCopyWeek();

export type CopyWeekResult = FacilityFlowCoreModulesPlanningDtosCopyWeekCopyWeekResultDto;

interface PlanningWeeksState {
  planEntries: FacilityFlowApiControllersPlanningPlanningWeeksControllerPlanEntryDto[];
  loading: boolean;
  error?: string;

  fetchPlanEntries: (year: number, week: number) => Promise<void>;
  /** Plan einer ISO-Woche in eine andere übernehmen (FAFD-10); Fehler wirft der Aufruf weiter. */
  copyWeek: (
    source: { year: number; week: number },
    target: { year: number; week: number },
    employeeIds: string[],
  ) => Promise<CopyWeekResult>;
}

export const usePlanningWeeksStore = create<PlanningWeeksState>((set) => ({
  planEntries: [],
  loading: false,

  fetchPlanEntries: async (year: number, week: number) => {
    set({ loading: true, error: undefined });
    try {
      const response = await api.getApiV1PlanningWeeksYearWeek(year, week);
      set({ planEntries: response ?? [], loading: false });
    } catch (err) {
      set({
        error: 'Fehler beim Laden der Wochenplan-Einträge',
        loading: false,
      });
      throw err;
    }
  },

  copyWeek: async (source, target, employeeIds) =>
    copyWeekApi.postApiV1PlanningWeeksYearWeekCopyToTargetYearTargetWeek(
      source.year,
      source.week,
      target.year,
      target.week,
      { employeeIds },
    ),
}));
